import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common Components
import { Button, Form, TextInput, ToggleSwitch } from "src/Components";
// Services
import { addStrategy, editStrategy } from "src/Requests/deltaHedgeAccounts";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import type { IStrategyDto } from "src/Interfaces/deltaHedgeAccounts";

interface IProps {
  editValues?: IStrategyDto;
  onClose: () => void;
  onSuccess: () => void;
}
const AddEditStrategyModal: React.FC<IProps> = (props) => {
  const [formValues, setFormValues] = React.useState(
    props.editValues ||
      ({
        tradebase: false,
        buyCall: false,
        sellCall: false,
        buyPut: false,
        sellPut: false,
      } as IStrategyDto)
  );
  const [loading, setLoading] = React.useState(false);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const properFunction = () =>
    props.editValues ? editStrategy(formValues) : addStrategy(formValues);

  const clickHandler = () => {
    setLoading(true);
    properFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          props.onSuccess();
          props.onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2">
      <TextInput
        label="نام استراتژی"
        value={formValues.strategyName}
        name="strategyName"
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="نام اضافه شونده"
        value={formValues.suffix}
        name="suffix"
        onChange={changeHandler}
        extraLabel
      />
      <div className="mr-3">
        <ToggleSwitch
          checked={formValues.tradebase}
          label="نماد پایه"
          name="tradebase"
          onChange={changeHandler}
        />
      </div>
      <div className="flex gap-2 justify-around items-center w-full">
        <ToggleSwitch
          checked={formValues.buyCall}
          label="خرید کال"
          name="buyCall"
          onChange={changeHandler}
        />
        <ToggleSwitch
          checked={formValues.sellCall}
          label="فروش کال"
          name="sellCall"
          onChange={changeHandler}
        />
      </div>
      <div className="flex gap-2 justify-around items-center w-full">
        <ToggleSwitch
          checked={formValues.buyPut}
          label="خرید پوت"
          name="buyPut"
          onChange={changeHandler}
        />
        <ToggleSwitch
          checked={formValues.sellPut}
          label="فروش پوت"
          name="sellPut"
          onChange={changeHandler}
        />
      </div>

      <Button
        text="ثبت"
        onClick={clickHandler}
        variant="contained"
        loading={loading}
      />
    </Form>
  );
};

export default AddEditStrategyModal;
